import {cn} from "@/lib/utils";

import {useStoredCompany} from "@/src/modules/company/store";

import {DirectMessagesSidebarLink} from "@/src/modules/direct-messages/components/direct-messages-sidebar-link";

import {NotificationFeedBellButton} from "@/src/modules/notification-feed/components";

import {useIsMobile} from "../hooks";
import {useStoredMe} from "../store/me";

import {APP_BRAND_NAME, LOGO_URL_DESKTOP} from "../utils/constants";
import {
  APP_CONTENT_COLUMN_RIGHT_CSS_VAR,
  DESKTOP_APP_HEADER_HEIGHT_CLASS,
} from "../lib/desktop-app-header";
import {NavUser} from "./nav-user";
import {ResidentBoardNavTrigger} from "./resident-board-nav-sheet";
import {ResidentBrandHomeLink} from "./resident-brand-home-link";
import {ResidentContextSwitcher} from "./resident-context-switcher";

export default function DesktopHeader() {
  const isMobile = useIsMobile();
  const company = useStoredCompany();
  const me = useStoredMe();
  const isResidentShell = Boolean(me?.isResident);

  if (isMobile) {
    return null;
  }

  return (
    <header
      className={cn(
        "bg-background text-foreground relative z-20 flex w-full shrink-0 items-center border-b border-border",
        DESKTOP_APP_HEADER_HEIGHT_CLASS,
      )}
    >
      <div
        className={cn(
          "flex shrink-0 px-4 md:px-6",
          !isResidentShell && "min-w-[var(--sidebar-width)]",
        )}
      >
        <ResidentBrandHomeLink
          isResident={isResidentShell}
          className="flex items-center gap-3 px-1 py-0.5 -mx-1"
        >
          <img
            alt={`${APP_BRAND_NAME} logo`}
            className="size-9 shrink-0 rounded-sm"
            src={LOGO_URL_DESKTOP}
          />
          <div>
            <h1 className="text-base leading-tight font-semibold whitespace-nowrap">
              {company?.name ?? APP_BRAND_NAME}
            </h1>
            {company?.name ? (
              <p className="text-muted-foreground text-xs whitespace-nowrap sm:block">
                {APP_BRAND_NAME}
              </p>
            ) : null}
          </div>
        </ResidentBrandHomeLink>
      </div>
      <div className="min-w-0 flex-1 px-4 md:px-6">
        {isResidentShell ? <ResidentContextSwitcher variant="inline" /> : null}
      </div>
      {isResidentShell ? (
        <div className="flex shrink-0 items-center justify-end gap-2 px-4 md:px-6">
          <ResidentBoardNavTrigger />
          <DirectMessagesSidebarLink />
          <NotificationFeedBellButton className="shrink-0" />
          <NavUser me={me} variant="header" />
        </div>
      ) : (
        <div
          className="fixed z-30 flex items-center justify-end gap-2 px-4 md:px-6"
          style={{
            top: 0,
            height: "var(--app-desktop-header-height)",
            left: `var(${APP_CONTENT_COLUMN_RIGHT_CSS_VAR}, 100vw)`,
            transform: "translateX(-100%)",
          }}
        >
          <DirectMessagesSidebarLink />
          <NotificationFeedBellButton className="shrink-0" />
        </div>
      )}
    </header>
  );
}
